export const Models = {
    turno: (row) => ({
        idTurno: row.idTurno ?? row.IdTurno ?? 0,
        clave: row.clave ?? row.Clave ?? '',
        nombre: row.nombre ?? row.Nombre ?? '',
        horaInicio: row.horaInicio ?? row.HoraInicio ?? '',
        horaFin: row.horaFin ?? row.HoraFin ?? '',
        descripcion: row.descripcion ?? row.Descripcion ?? '',
        horaComidaInicio: row.horaComidaInicio ?? row.HoraComidaInicio ?? '',
        horaComidaFin: row.horaComidaFin ?? row.HoraComidaFin ?? '',
    }),
    empleadosTurnos: (row) => ({
        idEmpleadoTurno: row.idEmpleadoTurno ?? row.IdEmpleadoTurno ?? 0,
        idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? 0,
        idTurno: row.idTurno ?? row.IdTurno ?? 0,
        fechaAsignacion: row.fechaAsignacion ?? row.FechaAsignacion ?? null,
    })
};
